import React, { useEffect } from "react";
import { isIOS, isAndroid, isDesktop } from "react-device-detect";
import { GooglePlayButton, AppStoreButton } from "react-mobile-app-button";
import logo from "./logo.svg";
import "./App.css";

const IOS_STORE = "https://apps.apple.com/us/app/chall/id6447187230";
const ANDROID_STORE = "https://play.google.com/store/apps/details?id=com.chall";

function App() {
  useEffect(() => {
    if (isIOS) {
      window.location.replace(IOS_STORE);
      return;
    }
    if (isAndroid) {
      window.location.replace(ANDROID_STORE);
      return;
    }
    // Desktop users stay here and see install buttons
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="Chall" />
        <p>Chall</p>

        {isDesktop && (
          <>
            <GooglePlayButton
              url={ANDROID_STORE}
              theme="dark"
              width={276}
              height={40}
              className="install-app"
            />
            <AppStoreButton
              url={IOS_STORE}
              theme="dark"
              width={276}
              height={40}
              className="install-app"
            />
          </>
        )}
      </header>
    </div>
  );
}

export default App;
